// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3240":"9cdf8768","5972":"2b94b7e9","9933":"6806ca58"}[chunkId] + ".css";
};